import cl from 'clsx';

import { ReferrerInfo } from '@/true-fsd/features/ReferrerInfo';
// import { ReferralsTable } from '@/true-fsd/features/ReferralsTable';

import classes from './ReferralPage.module.scss';

export type ReferralPageProps = {
  className?: string;
};
export const ReferralPage = ({ className }: ReferralPageProps) => {
  return (
    <div className={cl(classes.root, className)}>
      <h2 className={classes.header}>Реферальная программа</h2>
      <ReferrerInfo />
      {/* <ReferralsTable /> */}
    </div>
  );
};
